module.exports = __webpack_public_path__ + "static/media/biznes.3d4d1c49.jpg";